import KeenSlider from 'keen-slider';

export const SpeakCarrousel = {
  init: function () {
    this.cacheSelectors();
    this.bindEvents();
  },

  cacheSelectors: function () {
    this.sliderElement = document.querySelector("#speak-about");
    this.prevButton = document.querySelector(".arrow__prev");
    this.nextButton = document.querySelector(".arrow__next");
    this.isMobile = window.matchMedia("(max-width: 768px)");
  },

  bindEvents: function () {
    if (!this.sliderElement) {
      return;
    }

    const options = this.getOptions();
    this.sliderInstance = new KeenSlider(this.sliderElement, options, [
      (slider) => this.initializeSlider(slider),
    ]);

    window.addEventListener('resize', this.handleResize.bind(this));
  },

  getOptions: function () {
    return {
      loop: false,
      mode: "snap",
      rtl: false,
      slides: {
        perView: this.isMobile.matches ? 1.3 : 3,
        spacing: 30,
      },
    };
  },

  initializeSlider: function (slider) {
    const updateButtonStates = () => {
      const { rel, slides } = slider.track.details;

      if (this.prevButton) {
        this.prevButton.classList.toggle('arrow--disabled', rel === 0);
      }

      if (this.nextButton) {
        this.nextButton.classList.toggle('arrow--disabled', rel === slides.length - 1);
      }
    };

    this.prevButton?.addEventListener('click', () => slider.prev());
    this.nextButton?.addEventListener('click', () => slider.next());

    slider.on('created', updateButtonStates);
    slider.on('slideChanged', updateButtonStates);
  },

  handleResize: function () {
    const options = this.getOptions();
    this.sliderInstance?.update({
      slides: {
        perView: options.slides.perView,
      },
    });
  },
};

SpeakCarrousel.init();
